import { useMemo } from 'react'

import type { CardDetailsListItem } from 'Components/CardDetailsList/CardDetailsList.types'
import { FormatDate } from 'Components/FormatDate/FormatDate'
import { PresentationCard } from 'Components/PresentationCard/PresentationCard'
import { ReturnPortalStatusBadge } from 'Components/ReturnPortalStatusBadge/ReturnPortalStatusBadge'

import type { DeviceTypeEnum } from 'Types/deviceTypes'

import type { ReturnPresentationCardProps } from './ReturnPresentationCard.types'

export const ReturnPresentationCard = (props: ReturnPresentationCardProps) => {
  const { returnCase } = props

  const generatePresentationCardListItems = useMemo(
    (): CardDetailsListItem[] => [
      {
        label: 'ReturnDetails_serial_number',
        value: returnCase.stocklistItem?.serialNumber,
      },
      {
        label: 'ReturnDetails_imei',
        value: returnCase.stocklistItem?.imei,
      },
      {
        label: 'ReturnDetails_imei2',
        value: returnCase.stocklistItem?.imei2,
      },
      {
        label: 'ReturnDetails_start_of_rental',
        value: <FormatDate value={returnCase.rental?.startAt} />,
      },
    ],
    [returnCase],
  )

  const renderRightContent = useMemo(
    () => <ReturnPortalStatusBadge portalStatus={returnCase.portalStatus} />,
    [returnCase.portalStatus],
  )

  if (!returnCase.stocklistItem) {
    return null
  }

  return (
    <PresentationCard
      header={returnCase.stocklistItem.deviceDefinition?.name || ''}
      imagePlaceholderType={
        returnCase.stocklistItem.deviceDefinition?.productType as DeviceTypeEnum
      }
      imageSource={returnCase.stocklistItem.deviceDefinition?.imageURL}
      listItems={generatePresentationCardListItems}
      rightContent={renderRightContent}
      title="ReturnDetails_device"
    />
  )
}
